export default __webpack_public_path__ + "static/media/ElectricityIsEverywhere_02.b4e50ff3.png";